import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react";
import { Grid, styled } from "@material-ui/core";
import { lang } from "../i18nLang";

import TopBar from "../components/shared/TopBar";
import LoginForm from "../components/Login/LoginForm";
import RegisterForm from "../components/Login/RegisterForm";
import { DialogModalInputs } from "../components/UI/DialogModals";
import { SystemMessageSnack } from "../components/UI/System";

import AuthController from "../api/controllers/AuthController";
import { UserStore, MessageStore } from "../store";
import { AuthException } from "../api/exceptions/AuthException";

const HeaderWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  height: 60,
  padding: theme.spacing(0.5, 4, 0.5, 0.5),
  lineHeight: "60px",
  textAlign: "right",
  "& button": {
    marginLeft: theme.spacing(5),
  },
  [theme.breakpoints.up("md")]: {
    paddingRight: theme.spacing(25),
  },
}));

const FormWrapper = styled("div")(({ theme }) => ({
  maxWidth: 720,
  width: "100%",
  margin: "0 auto",
  padding: theme.spacing(4),
  paddingTop: theme.spacing(14),
}));

const Login = observer(() => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [openRecoverModal, setOpenRecoverModal] = useState(false);
  const [showRegister] = useState(false);

  useEffect(() => {
    UserStore.verifyCurrentSession((userAuthenticated) => {
      setLoading(false);
      if (userAuthenticated) {
        history.push("/kanban");
      }
    });
  }, [history]);

  const handleFormLoginSubmit = async (formData: any) => {
    try {
      let user = await UserStore.signInWithEmail(
        formData.email,
        formData.password
      );
      if (user && UserStore.isAthenticated) {
        redirect();
      }
    } catch (error: any) {
      setMessageError(error, lang("login.error"));
    }
  };

  const handleFormCreateSubmit = async (formData: any) => {
    try {
      let user = await UserStore.createUserAccount(
        formData.name,
        formData.email,
        formData.password
      );
      if (user && UserStore.isAthenticated) {
        redirect();
      }
    } catch (error: any) {
      setMessageError(error, lang("login.register.error"));
    }
  };

  const handleConfirmRecover = async (data: any) => {
    if (data) {
      try {
        await AuthController.sendPasswordResetEmail(data.email);
        MessageStore.info(lang("login.resetPassword.emailSent"));
      } catch (error: any) {
        setMessageError(error, lang("login.resetPassword.emailErrorSent"));
      }
    }
  };

  // const handleToogleRegister = () => {
  //   setShowRegister(!showRegister);
  // };

  const handleToogleModal = (open: boolean) => () => {
    setOpenRecoverModal(open);
  };

  function redirect() {
    history.push("/kanban");
  }

  function setMessageError(error: any, defaultMessage: string) {
    let message = defaultMessage;
    if (error) {
      console.error("Login fail: ", error.name, error.message);
      if (error instanceof AuthException) {
        message = error.message;
      }
    }

    MessageStore.error(message);
  }

  return (
    <Grid container>
      {loading ? (
        <div></div>
      ) : (
        <>
          <TopBar />
          <Grid item xs={12}>
            <HeaderWrapper>
              {/* 
              <Typography variant="subtitle1" display="inline">
                {showRegister
                  ? lang("login.alreadyHaveAnAccount")
                  : lang("login.dontHaveAnAccount")}
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleToogleRegister}
              >
                {showRegister
                  ? lang("login.goToLogin")
                  : lang("login.startNow")}
              </Button> */}
            </HeaderWrapper>
            <FormWrapper>
              {showRegister ? (
                <RegisterForm onSubmit={handleFormCreateSubmit} />
              ) : (
                <LoginForm
                  onSubmit={handleFormLoginSubmit}
                  onClickRecover={handleToogleModal(true)}
                />
              )}
            </FormWrapper>
            <DialogModalInputs
              title={lang("resetPassword")}
              open={openRecoverModal}
              onClose={handleToogleModal(false)}
              onConfirm={handleConfirmRecover}
              confirmLabel={lang("reset")}
              fields={[
                {
                  name: "email",
                  label: "E-mail",
                  type: "email",
                  required: true,
                },
              ]}
            />
          </Grid>
          <SystemMessageSnack />
        </>
      )}
    </Grid>
  );
});

export default Login;
